<template>
  <div class="max-w-lg m-auto mt-20">

    <div class="p-8 bg-white my-6 rounded border">

      <div class="text-2xl uppercase font-thin text-gray-700">
        You have been logged out.
      </div>

      <div class="mt-8">
        <label class="text-base leading-normal">
          Thank you. You have now successfully logged out. If you would like to 
          log back in again, please click on the link in the email.
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    mounted() {
      document.body.className = 'bg-gray-100'
    },

    beforeDestroy() {
      document.body.className = ''
    },
  }
</script>